import { defineComponent as _defineComponent } from 'vue'
import type { GetSamlConnectionsResponse } from '@/interfaces/api/general/saml';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { formatToDate } from '@/utils/datetime';


export default /*#__PURE__*/_defineComponent({
  __name: 'SamlSettingCard',
  props: {
    samlSetting: null
  },
  setup(__props: any) {

const props = __props as {
  samlSetting: GetSamlConnectionsResponse[0];
};

const m = defineMessages({
  updatedAt: '設定完了日：',
  entityId: 'エンティティID',
  acsUrl: 'ACS URL',
  sloUrl: 'SLO URL',
  nameId: 'Name ID形式',
});



return { __sfc: true,m, props, sharedMessages, formatToDate }
}

})